import * as Yup from 'yup';
export const initialCoachValues = {
    areaOfOperation: '',
    secondaryAreaOfOperation: '',
    startDate: undefined,
    signingSignature: undefined,
    franchisorId: '',
};
export const coachSchema = Yup.object().shape({
    areaOfOperation: Yup.string(),
    secondaryAreaOfOperation: Yup.string(),
    startDate: Yup.date(),
    signingSignature: Yup.string(),
    sendInvite: Yup.bool(),
    franchisorId: Yup.string(),
});
//# sourceMappingURL=coach.js.map